<template>
  <PForm
    v-model="validado"
    @cancel="limpiar"
    @accept="action"
    :action="actionName"
    :textAction="textActionName"
    :textCancel="$t('action.limpiar')"
  >
    <template>
      <PRow>
        <PCol md="12">
          <PFormDatepicker
            v-model="valueLocal.fechaInicio"
            :label="$t('label.fechaInicio')"
            :endSelector="valueLocal.fechaFin"
            :language="locale"
          ></PFormDatepicker>
        </PCol>
        <PCol md="12" v-if="maxRangeMonth || maxRangeMonth === undefined">
          <PFormDatepicker
            v-model="valueLocal.fechaFin"
            :label="$t('label.fechaFin')"
            :startSelector="valueLocal.fechaInicio"
            :language="locale"
            :maxRangeMonth="maxRangeMonth"
          ></PFormDatepicker>
        </PCol>
        <PCol md="12">
          <PFormSelectMulti
            v-model="valueLocal.delegationsSelected"
            :options="delegations"
            optionValue="id"
            optionText="desDelegacion"
            :label="$t('label.delegaciones')"
            :placeholder="$t('option.select')"
            :readonly="delegations.length === 0"
          />
        </PCol>
        <PCol md="12" v-if="tiposDocumentos.length > 0">
          <PFormSelect
            v-model="valueLocal.tipoDocumentoSelected"
            :options="aTipoDocumentoOption"
            optionValue="codParametro"
            optionText="desParametro"
            :label="$t('label.tipoDocumento')"
            :placeholder="$t('option.select')"
          ></PFormSelect>
        </PCol>
      </PRow>
    </template>
  </PForm>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PSidebar from "@/components/look/PSidebar/PSidebar.vue";
import { Getter } from "vuex-class";
import { ICliente, IDelegacion, IParametro } from "@/entities";
import { Locale } from "@/store";
import VueMethods from "@/vue-methods";

@Component({
  components: { PSidebar },
  mixins: [VueMethods],
})
export default class DocumentacionTableFilters extends Vue {
  @Prop({ required: false })
  textActionName!: string;
  @Prop({ required: false })
  actionName!: string;
  @Prop({ required: false })
  tiposDocumentos!: IParametro[];
  @Prop({ required: false })
  maxRangeMonth?: number;

  @Getter("getLocale") locale!: Locale;
  @Getter("getClienteSelected") clienteSelected!: ICliente;

  @Prop({ required: true }) value!: any;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.valueLocal = JSON.parse(JSON.stringify(this.value));
    this.$set(
      this.valueLocal,
      "fechaInicio",
      this.valueLocal.fechaInicio
        ? new Date(this.valueLocal.fechaInicio!)
        : this.getStartDate(new Date().toISOString())
    );
    this.$set(
      this.valueLocal,
      "fechaFin",
      this.valueLocal.fechaFin
        ? new Date(this.valueLocal.fechaFin!)
        : this.getEndDate(new Date().toISOString())
    );
  }
  validado = false;
  valueLocal = {
    fechaInicio: this.getStartDate(new Date().toISOString()),
    fechaFin: this.getEndDate(new Date().toISOString()),
    delegationsSelected: [],
    tipoDocumentoSelected: null,
  };
  initialValueLocal = {
    fechaInicio: this.getStartDate(new Date().toISOString()),
    fechaFin: this.getEndDate(new Date().toISOString()),
    delegationsSelected: [],
    tipoDocumentoSelected: null,
  };

  get delegations(): IDelegacion[] {
    let delegationsList: IDelegacion[] = [];
    this.clienteSelected?.clientexdels.forEach((clientexdel) => {
      if (clientexdel.active) delegationsList.push(clientexdel.delegacion);
    });
    return delegationsList.sort((a, b) => this.sortAscending(a, b, "desDelegacion"));
  }

  get aTipoDocumentoOption(): IParametro[] {
    const tipos = JSON.parse(JSON.stringify(this.tiposDocumentos)) as IParametro[];
    return tipos
      .map((tipoDocumento) => {
        const label = `documento.tipo.${tipoDocumento.codParametro?.toLowerCase()}`;
        tipoDocumento.desParametro = this.$te(label) ? this.$t(label) : tipoDocumento.desParametro;
        return tipoDocumento;
      })
      .sort((a, b) => this.sortAscending(a, b, "desParametro"));
  }

  limpiar(): void {
    this.$set(this.valueLocal, "fechaInicio", this.getStartDate(new Date().toISOString()));
    this.$set(this.valueLocal, "fechaFin", this.getEndDate(new Date().toISOString()));
    this.valueLocal.delegationsSelected = [];
    this.valueLocal.tipoDocumentoSelected = null;
    if (!this.isInitialObject(this.value, this.initialValueLocal)) {
      this.$emit("input", this.valueLocal);
      this.$emit("cancel", { action: "clean" });
    }
  }
  action(action: string): void {
    this.$emit("input", this.valueLocal);
    this.$emit("action", { action: action });
  }
}
</script>

<style lang="scss" scoped>
.filter-btn {
  object-fit: contain;
  border-radius: 19.8px;
  border: solid 1px var(--amarillo-prosegur);
  padding-left: 24px;
}

.filter-label {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  padding-left: 12px;
  padding-right: 12px;
}

.divHeaderSidebar {
  position: relative;
  width: 100%;
  display: inline-flex;
  align-items: center;
}

.divHeaderSidebarTitle {
  padding-left: 2rem;
}

.HeaderSidebarClose {
  cursor: pointer;
}

.HeaderSidebarAspa {
  font-size: 2rem;
  opacity: 0.5;
}

.divHeaderSidebarTitleText {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}

.HeaderSidebarBorde {
  box-shadow: 0 0 5px 0 #e5e9f2;
}

.p_form_input_text_label {
  text-transform: uppercase;
  color: #b7b7b7;
  margin-bottom: 3px;
}

.p_form_input_text {
  border-top: 0 !important;
  border-bottom: solid 1px #b7b7b7 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-radius: 0 !important;
  width: 100%;
  padding: 8px;
  color: #4c4c4c;
}

.filter-container {
  padding: 1rem;
}
</style>
